import {
  addDemand
} from '@/api/demands/demand'

const state = {}

const actions = {
  // 定制需求
  DEMAND_ADD_CUSTOMIZED ({ commit }, params) {
    return addDemand(params)
  }
}

const getters = {}

const mutations = {}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/demands/demand.js